import { Component } from '@angular/core';
import { TooltipTriggerDirective } from '@group24ag/flowkit';

@Component({
  selector: 'app-ui-tooltips',
  imports: [TooltipTriggerDirective],
  template: `
    <div>
      <h1 class="heading-title">Tooltips</h1>
      <div class="flex gap-10">
        <div class="flex flex-col justify-between gap-5 text-nowrap!">
          <span
            class="w-min"
            flkTooltipTrigger
            [tooltip]="'My tooltip'"
            position="above"
            alignment="end">
            Above + End
          </span>
          <span
            class="w-min"
            flkTooltipTrigger
            [tooltip]="'My tooltip'"
            position="below">
            Below + Center
          </span>
          <span
            class="w-min"
            flkTooltipTrigger
            [tooltip]="'My tooltip'"
            position="right"
            alignment="end">
            Right + End
          </span>
          <span
            class="w-min"
            flkTooltipTrigger
            [tooltip]="'My tooltip'"
            position="left">
            Left + Center
          </span>
        </div>
      </div>
    </div>
  `,
})
export class UITooltipsComponent {}
